import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import PodcastsTable from "../PodcastsListing/PodcastsTable";

const COPY = {
  title: "Manage Podcasts",
  subtitle: "You Can View & Delete Podcasts",
  searchPlaceholder: "Search Here",
};

const PodcastsAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getPodcasts");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <PodcastsTable driverData={items} />
    </AdminPage>
  );
};

export default PodcastsAdmin;
